<mat-icon>{{icon}}</mat-icon>
